import VCheckbox from './VCheckbox'
import VRadio from './VRadio'
import VSwitch from './VSwitch'

export default {
  VCheckbox,
  VRadio,
  VSwitch
}



// WEBPACK FOOTER //
// ./src/components/selection-controls/index.js